module.exports = __webpack_public_path__ + "img/video.8b88888e.png";